(function () {
  function init(root) {
    var apiUrl = root.dataset.apiUrl;
    var token = new URLSearchParams(window.location.search).get('token') || '';
    var panel = root.querySelector('[data-preferences-panel]');
    var loading = root.querySelector('[data-preferences-loading]');
    var content = root.querySelector('[data-preferences-content]');
    var heading = root.querySelector('[data-preferences-heading]');
    var message = root.querySelector('[data-preferences-message]');
    var button = root.querySelector('[data-unsubscribe]');
    function show(title, copy, state, allowAction) {
      loading.hidden = true; content.hidden = false; heading.textContent = title; message.textContent = copy;
      panel.classList.remove('is-success', 'is-error'); if (state) panel.classList.add(state);
      button.hidden = !allowAction;
    }
    function request(action) {
      return fetch(apiUrl, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ type: 'email-marketing-preferences', action: action, token: token }) })
        .then(function (response) { return response.json(); });
    }
    if (!apiUrl || !token) { show('Link unavailable', 'Open the full preferences link from one of our emails.', 'is-error', false); return; }
    request('status').then(function (data) {
      if (!data.ok) throw new Error(data.error || 'Invalid link.');
      if (data.unsubscribed) show('Already unsubscribed', 'You will not receive marketing emails from Heathrow Boxing Club.', 'is-success', false);
      else show('Marketing emails', 'You can stop club news, offers and rebooking reminders at any time. Booking confirmations and essential service emails are unaffected.', '', true);
    }).catch(function (error) { show('Unable to continue', error.message || 'Please try again.', 'is-error', false); });
    button.addEventListener('click', function () {
      button.disabled = true; button.textContent = 'Unsubscribing...';
      request('unsubscribe').then(function (data) {
        if (!data.ok) throw new Error(data.error || 'Unable to unsubscribe.');
        show('Unsubscribed', 'Your marketing emails have been stopped. Booking confirmations and essential service emails are unaffected.', 'is-success', false);
      }).catch(function (error) { button.disabled = false; button.textContent = 'Try again'; show('Unable to continue', error.message || 'Please try again.', 'is-error', true); });
    });
  }
  document.querySelectorAll('[data-hbc-email-preferences]').forEach(init);
}());
